// extracted by mini-css-extract-plugin
module.exports = {"Tabs":"Tabs_Tabs__qKixZ","active":"Tabs_active__1XLmF"};